var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteEnabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.923,
    height: 79.276,
    viewBox: "0 0 74.923 79.276",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_904",
    "data-name": "Group 904",
    transform: "translate(-1829.93 -2357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Details",
    transform: "translate(1829.93 2357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_890",
    "data-name": "Group 890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_889",
    "data-name": "Group 889"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M37.251,70.884H8.6a3.063,3.063,0,0,1-2.862-3.222V12.888H62.983V40.066a7.925,7.925,0,0,1,3.844-1.037,7.818,7.818,0,0,1,1.881.242V9.666C68.707,4.327,64.86,0,60.12,0H8.6C3.859,0,.012,4.327.012,9.666v58C.012,73,3.859,77.328,8.6,77.328H35.576Z",
    transform: "translate(-0.012)",
    fill: "#007cab"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_841",
    "data-name": "Group 841",
    transform: "translate(2435.403 740.141) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_106",
    "data-name": "Line 106",
    x2: 28.685,
    y2: 28.685,
    transform: "translate(1662.5 535.5)",
    fill: "none",
    stroke: "#c82640",
    strokeLinecap: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_107",
    "data-name": "Line 107",
    x2: 28.685,
    y2: 28.685,
    transform: "translate(1691.185 535.5) rotate(90)",
    fill: "none",
    stroke: "#c82640",
    strokeLinecap: "round",
    strokeWidth: 7
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteEnabled);
export default __webpack_public_path__ + "static/media/Delete_Enabled.34a07549453d9eddacd7677455eaf3c6.svg";
export { ForwardRef as ReactComponent };